import React, { useState } from "react";
import { ButtonGroup, Dropdown, DropdownButton, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { useAppApi } from "@/App";
import { useChoiceLabel } from "@/const";
import { useRequest } from "@components/AppHook";
import MarketSerialBatchStateDisplay from "@components/Displays/MarketSerialBatchStateDisplay";
import { DevForm, FormFieldGroup } from "@components/Forms/Fields";
import { DevModal, OverflowArea } from "@components/Helpers";
import { DefaultLayout } from "@components/Layouts";
import { ListingCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

export default function MarketSerialsScreen() {
    const { t } = useTranslation();
    const header = t("Ключи");
    return (
        <DefaultLayout>
            <List header={header} />
        </DefaultLayout>
    );
}

function List({ header }) {
    const { t } = useTranslation();
    const { apiData, setApiData, apiUrl } = useAppApi(url_reverse("api:market:serial:list"));
    const [ban, setBan] = useState({});
    const MarketSerialBatchSerialTypeTrans = useChoiceLabel("MarketSerialBatchSerialType");
    const { api_post } = useRequest();

    if (!apiData) return;

    const hideBan = () => setBan({});

    const doBan = (ev) => {
        api_post(ev, apiUrl, {
            params: { comment_ban: ban.comment, batch_ids: ban.ids },
            then: (resp) => {
                if (resp.status === "ok" && resp.bad.length === 0) {
                    hideBan();
                } else {
                    setBan((prev) => ({ ...prev, bad: resp.bad, good: resp.good }));
                }
            },
        });
    };

    const headerTools = (
        <DropdownButton as={ButtonGroup} size="sm" variant="dark" title={t("С выбранными")}>
            <Dropdown.Item
                onClick={() => {
                    const ids = apiData.object_list.filter((o) => o.chosen).map((o) => o.id);
                    if (ids.length) {
                        setBan((prev) => ({ ...prev, ids }));
                    }
                }}
            >
                {t("Бан")}
            </Dropdown.Item>
        </DropdownButton>
    );

    return (
        <ListingCard header={header} headerTools={headerTools}>
            <DevModal
                size="lg"
                show={ban.ids}
                onHide={hideBan}
                header={t("Бан")}
                body={
                    <FormFieldGroup label={t("Комментарий")} required={true}>
                        <DevForm.TextArea
                            name="comment"
                            value={ban.comment}
                            required={true}
                            onChange={(ev) => setBan((prev) => ({ ...prev, comment: ev.target.value }))}
                        />
                        {ban.good?.map((o, i) => {
                            return (
                                <div key={`good_${i}`} style={{ fontSize: "0.8rem", color: "green" }}>
                                    {o}
                                </div>
                            );
                        })}
                        {ban.bad?.map((o, i) => {
                            return (
                                <div key={`bad_${i}`} style={{ fontSize: "0.8rem", color: "red" }}>
                                    {o}
                                </div>
                            );
                        })}
                    </FormFieldGroup>
                }
                footer={
                    <DevForm.Button variant="primary" name="ban" onClick={doBan}>
                        {t("Применить")}
                    </DevForm.Button>
                }
            />

            <Table hover responsive className="dmg-table">
                <thead>
                    <tr>
                        <th style={{ width: "25px" }} />
                        <th>{t("ID партии")}</th>
                        <th>{t("Игра")}</th>
                        <th>{t("Компания")}</th>
                        <th>{t("Дата генерации")}</th>
                        <th>{t("Срок действия")}</th>
                        <th>{t("Логин")}</th>
                        <th>{t("Тип ключей")}</th>
                        <th>{t("Количество")}</th>
                        <th>{t("Комментарий")}</th>
                        <th>{t("Статус")}</th>
                    </tr>
                </thead>
                <tbody>
                    {apiData.object_list?.map((obj, i) => {
                        return (
                            <tr key={`object_list${i}`}>
                                <td>
                                    <DevForm.Checkbox
                                        checked={obj.chosen}
                                        onChange={(ev) => {
                                            const newApiData = { ...apiData };
                                            newApiData.object_list.map((o) => {
                                                if (o.id === obj.id) {
                                                    o.chosen = ev.target.checked;
                                                }
                                                return o;
                                            });
                                            setApiData(newApiData);
                                        }}
                                    />
                                </td>
                                <td>
                                    <Link to={url_reverse("games:serials", { game_id: obj.game.id })}>{obj.id}</Link>
                                </td>
                                <td>
                                    <Link to={url_reverse("games:admin", { game_id: obj.game.id })}>
                                        {obj.game.base_locale_object.name}
                                    </Link>
                                </td>
                                <td>
                                    <Link to={url_reverse("devs:edit", { dev_id: obj.__developer.id })}>
                                        {obj.__developer.name}
                                    </Link>
                                </td>
                                <td>{obj.date_added}</td>
                                <td>{t("Бессрочно")}</td>
                                <td>{obj.author_email}</td>
                                <td>{MarketSerialBatchSerialTypeTrans[obj.serial_type]}</td>
                                <td>{obj.amount}</td>
                                <td className="show-wrap-text">
                                    <OverflowArea y={150}>{obj.comment}</OverflowArea>
                                </td>
                                <td>
                                    <MarketSerialBatchStateDisplay batch={obj} />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        </ListingCard>
    );
}
